module.exports = __webpack_public_path__ + "images/store_case_study/turtle-pic2_5a4782fcbd416beb85b63d20e58d2545.png";